import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Delete = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [visible, setVisible] = useState(true);
  const cancel = () =>
    navigate(SCREENS.PRIVATE.ADMIN.COMMISSION_STATEMENTS.LIST.path);
  const [deleteCommissionStatement] = useMutation(
    graphql.mutations.DELETE_COMMISSION_STATEMENT,
    {
      refetchQueries: [
        {
          query: graphql.queries.COMMISSION_STATEMENTS,
          awaitRefetchQueries: true,
          variables: {
            ...INITIAL_VALUES,
            orderBy: [{ year: "DESC" }, { month: "DESC" }],
            where: {},
          },
        },
      ],
      onCompleted: () => {
        setVisible(false);
        navigate(SCREENS.PRIVATE.ADMIN.COMMISSION_STATEMENTS.LIST.path, {
          replace: true,
        });
      },
    },
  );
  const onSubmit = () => {
    return deleteCommissionStatement({
      variables: {
        where: {
          id,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} cancel={cancel} visible={visible} />;
};

export default Delete;
